import { Email, renderFieldVerticalWrapper } from '@wkda/carlead-creation-components';
import { useTrackElementView } from '../../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailWithTracking = () => {
  useTrackElementView(typeof window !== 'undefined' ? document.getElementById('email') : null, {
    category: 'lead-form',
    action: 'field-visible',
    leadFieldVisible: 'email',
    method: 'user'
  }, 'lead-form');
  return /*#__PURE__*/_jsx(Email, {
    isHiddenField: true,
    renderFieldWrapper: renderFieldVerticalWrapper
  });
};
export default EmailWithTracking;